
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Footer() {
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-12 bg-background" id="main-footer">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between mb-8">
          <div className="mb-4 md:mb-0">
            <Link to="/" className="block">
              <img 
                src="/lovable-uploads/e30c77e4-df79-4151-8b5c-57deb4d140d4.png" 
                alt="Vitatee Logo" 
                className="h-10" 
              />
              <span className="sr-only">Vitatee - Your AI wellness partner</span>
            </Link>
          </div>
          <div className="flex space-x-6">
            {user ? (
              <>
                <Link to="/dashboard" className="text-muted-foreground hover:text-primary transition-colors">
                  Dashboard
                </Link>
                <Link to="/profile" className="text-muted-foreground hover:text-primary transition-colors">
                  Profile
                </Link>
              </>
            ) : (
              <Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors">
                Pricing
              </Link>
            )}
            <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
              Blog
            </Link>
            <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
              Privacy
            </Link>
          </div>
        </div>
        <div className="border-t pt-8 text-center text-sm text-muted-foreground">
          <p>© {currentYear} Vitatee. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
